import { apiService } from 'services/base.service';
import { MealType } from 'utils/types';

export const getBaseMealCategory = async () => {
  try {
    const res = await apiService.get('base/meal-category', {});

    if (res.data) {
      return res.data.data;
    }
  } catch {
    console.log('error');
  }
};
export const getBaseMeals = async (
  setBaseMeals: (arg0: MealType[]) => void,
  unpaginated?: boolean
) => {
  const API_URL = unpaginated ? 'base/meals/names' : 'base/meals';
  try {
    const res: any = await apiService.get(API_URL, {});

    if (res?.data?.data) {
      setBaseMeals(res.data.data);
    }
  } catch {
    console.log('error');
  }
};
export const getBaseAddonCategory = async (unpaginated?: boolean) => {
  try {
    const API_URL = unpaginated ? 'base-addon-category/names' : 'base-addon-category';
    const res: any = await apiService.get(API_URL, {
      isInternal: true
    });
    if (res?.data) {
      return res?.data?.data?.data || res?.data?.data;
    }
  } catch {
    console.log('error');
  }
};
